import * as actions from "../../utils/Actions";
const initialState = { 
    showToast: false,
    error: false,
    message: null,
}

export default function global(state = initialState, action){

    if (typeof state === 'undefined') {
        return state;
    }
    switch (action.type) {
        //shoe error toast
        case actions.SHOW_ERROR_TOAST:
          return {
            ...state,
            showToast: true,
            error: true,
            message: action.meta.message
          }
        // reset toast 
        case actions.RESET_TOAST:
          return {
            ...state,
            showToast: false,
            error: false,
            message: null
        }
        default:
          return { ...state };
      }
    }